module.exports = __webpack_public_path__ + "media/animation_video.71eb8f81.webm";